<template>
    <el-upload
        class="upload-demo"
        accept="https://oss.saas.tling.vip/"
        :file-list="fileList.files.name"
        :before-upload="beforeUpload"
        multiple
        :limit="10"
        :on-exceed="handleExceed"
    >
        <el-button type="primary" size="mini">上传</el-button>
    </el-upload>
</template>

<script>
import request from "@/api/request";

export default {
    props: ['fileList', 'uploadProduct', 'uploadType'],
    data() {
        return {
            filename: '',
            uploadFile: {},
            uploadFileUrl: ''
        };
    },
    methods: {
        //上传文件
        handleExceed(files, fileList) {
            console.log(files)
            this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeUpload(file){
            console.log(file)
            this.filename = file.name
            this.uploadFile = file
            this.getBase64(file).then((res) => {
                //console.log(res)
                let base64Str = res.split(',')[1]
                if(!file.type) {
                    this.$message.warning('暂不支持此文件格式')
                    return
                }
                /*if(file.type.includes('image')) {
                    type = file.type.split('image/')[1]
                } else {
                    type = file.type.split('application/')[1]
                }*/
                let type = file.name.split(".").pop()
                this.handleUploadFile(base64Str, type, file.name)
            })
        },
        handleUploadFile(base64Str, type, name){
            //上传文件
            //console.log('type', type)
            request.saas
                .post("product/upload_product_appendix_file", {
                    content: base64Str,
                    suffix: type
                })
                .then(resp => {
                    this.uploadFileUrl = resp.data.url
                    this.uploadProductAppendix(resp.data.url, name)
                })
        },
        uploadProductAppendix(url, name){
            request.saas
                .post("product/upload_product_appendix", {
                    appendixes: [{
                        type: this.uploadType,
                        url: url,
                        filename: name,
                        status: 1  //1-生效  2-删除
                    }],
                    product_main_id: String(this.uploadProduct.id)
                })
                .then(() => {
                    let file = {
                        type: this.uploadType,
                        filename: name,
                        status: 1,
                        url: this.uploadFileUrl,
                        product_main_id: this.uploadProduct.id
                    }
                    this.$emit('handleChangeUpload', file)
                })
        },
        getBase64(file){
            return new Promise(function(resolve, reject) {
                let reader = new FileReader();
                let imgResult = null;
                reader.readAsDataURL(file);
                reader.onload = function() {
                    imgResult = reader.result;
                };
                reader.onerror = function(error) {
                    reject(error);
                };
                reader.onloadend = function() {
                    resolve(imgResult);
                };
            });
        }
    }
}
</script>
<style scoped>
>>> .avatar-uploader .el-upload{
    border: 0;
}
>>> .upload-demo{
    display: flex;
    flex-direction: row;
    align-items: center;
}
>>> .upload-demo .el-upload--text{
    margin-right: 20px;
}
</style>
